import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  Box,
  Drawer,
  IconButton,
  Popover,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';
import { useNotifications } from '../../hooks';
import { NotificationsLayout } from './notifications-layout';

export const NotificationsCenter: FC = () => {
  const { palette, spacing } = useTheme();
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation(['notificationCenter']);
  const { refetchCurrent, refetchHistory, refetchStatus, unreadCount } =
    useNotifications();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isMobile) {
      setAnchorEl(event.currentTarget);
    }
    setOpen(true);

    Promise.all([refetchCurrent(), refetchHistory(), refetchStatus()]);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        type="button"
        aria-label={t('notifications')}
      >
        <SystemIcon
          iconName="Bell"
          color={open ? 'primary' : undefined}
          sx={{ position: 'relative' }}
        />
        {unreadCount > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: 6,
              right: 10,
              width: 8,
              height: 8,
              backgroundColor: palette.error.main,
              outline: `3px solid ${palette.background.paper}`,
              borderRadius: 999,
            }}
          />
        )}
      </IconButton>

      {isMobile ? (
        <Drawer
          open={open}
          onClose={handleDrawerClose}
          slotProps={{
            paper: {
              sx: {
                width: '85%',
                backgroundColor: palette.background.contrast,
              },
            },
          }}
        >
          <NotificationsLayout setOpen={setOpen} />
        </Drawer>
      ) : (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          disableScrollLock
          slotProps={{
            paper: {
              sx: {
                width: 434,
                maxHeight: 680,
                marginTop: spacing(2),
                backgroundColor: palette.background.contrast,
                borderRadius: spacing(2),
                boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)',
              },
            },
          }}
        >
          <NotificationsLayout setOpen={setOpen} />
        </Popover>
      )}
    </>
  );
};
